import type { ChecklistItem, PackContract } from './types';

/** 계약 상대 경로. `clean-item-01`의 답에 따라 이후 문구가 갈린다. */
export const providerRoutes = ['certified_agency', 'brokerage_platform', 'unknown'] as const;
export type ProviderRoute = (typeof providerRoutes)[number];

/**
 * 경로별 기준선 표기. 가사근로자법은 제7조 인증을 받은 제공기관에만 적용되므로
 * 중개 플랫폼 경로에서 같은 항목을 법정 의무로 말하면 사실이 아니다.
 */
export const routeFraming: Record<ProviderRoute, { badge: string; note: string }> = {
  certified_agency: {
    badge: '법정 기재사항',
    note: '인증받은 가사서비스 제공기관과의 이용계약이라 아래 항목은 법에서 계약서에 적도록 정한 것들이에요.',
  },
  brokerage_platform: {
    badge: '참고 기준선',
    note: '중개 플랫폼을 통한 계약은 가사근로자법이 적용되지 않을 수 있어요. 아래 항목은 참고 기준이며, 물어볼 문장으로만 써요.',
  },
  unknown: {
    badge: '확인 필요',
    note: '계약 상대가 인증 제공기관인지 중개 플랫폼인지 먼저 확인하면 아래 항목의 성격이 정해져요.',
  },
};

const rows: Array<[string, string, string, string[], boolean, string]> = [
  ['clean-item-01','provider','계약 상대',['제공기관','중개','매칭','소속'],true,'이 계약을 인증받은 가사서비스 제공기관과 맺는 것인지, 중개 플랫폼을 통해 개인과 맺는 것인지 알려 주세요.'],
  ['clean-item-02','scope','청소 종류',['입주청소','정기청소','부분청소'],true,'이번 계약이 어떤 청소인지(입주·정기·부분) 확인 부탁드려요.'],
  ['clean-item-03','scope','포함 구역·작업',['기본 범위','서비스 범위'],true,'기본 범위에 포함되는 구역과 작업을 항목으로 알려 주세요.'],
  ['clean-item-04','scope','제외 구역·작업',['별도','불가','미포함'],true,'기본 범위에서 빠지는 구역과 작업이 무엇인지 알려 주세요.'],
  ['clean-item-05','scope','창문·창틀·방충망',['창틀','창문','샷시','유리','방충망'],true,'창문 안팎, 창틀, 방충망 중 어디까지 포함되는지 확인 부탁드려요.'],
  ['clean-item-06','scope','가전 내부',['냉장고','전자레인지','세탁조','후드'],true,'냉장고·전자레인지·세탁조 내부가 포함되는지, 별도라면 금액을 알려 주세요.'],
  ['clean-item-07','scope','면적·구조 기준',['평수','방 개수','복층','베란다'],true,'이번 금액이 몇 평, 방 몇 개 기준인지와 실제와 다를 때 처리를 알려 주세요.'],
  ['clean-item-08','scope','세제·도구 준비',['세제','청소도구','준비물','장비','소모품'],false,'세제와 청소도구를 누가 준비하는지 확인 부탁드려요.'],
  ['clean-item-09','price','총 이용요금',['총액','견적가','이용료'],true,'총 이용요금이 부가세를 포함해 얼마인지 회신 부탁드려요.'],
  ['clean-item-10','price','추가금 발생 조건',['추가금','현장 추가','초과요금','별도비용'],true,'현장에서 추가 금액이 붙는 경우와 그 기준 금액을 미리 알려 주세요.'],
  ['clean-item-11','price','지급 방법·시점',['지급','결제','선불','후불','계좌'],true,'요금을 언제 어떤 방법으로 지급하는지 확인 부탁드려요.'],
  ['clean-item-12','price','주차·출입 비용',['주차','주차비','공동현관','엘리베이터'],false,'주차비나 출입 관련 비용이 요금에 포함되는지 알려 주세요.'],
  ['clean-item-13','time','제공일·제공시간',['제공일','제공시간','방문일','작업시간','도착시각'],true,'방문 날짜와 시작·종료 예정 시간을 확인 부탁드려요.'],
  ['clean-item-14','time','시간 초과 처리',['초과','연장','추가시간','조기종료'],true,'예정 시간을 넘기거나 일찍 끝날 때 어떻게 처리되는지 알려 주세요.'],
  ['clean-item-15','time','휴일·휴가 시 조치',['휴일','명절','대체인력','휴무'],false,'공휴일이나 담당자 휴가에 어떻게 처리되는지 확인 부탁드려요.'],
  ['clean-item-16','change','내용·일정 변경 절차',['변경 절차','변경','연기','일정조정'],true,'범위나 날짜를 바꾸려면 언제까지 어떤 방법으로 알려야 하는지 확인 부탁드려요.'],
  ['clean-item-17','change','취소·해지 절차와 위약금',['위약금','취소','해지','취소수수료','환불'],true,'취소나 해지를 할 때의 절차와 금액 기준을 알려 주세요.'],
  ['clean-item-18','safety','파손·분실 배상',['파손','분실','손해배상','보험','변상'],true,'물건이 파손되거나 분실됐을 때 접수 방법과 필요한 자료를 알려 주세요.'],
  ['clean-item-19','safety','재청소·불만 처리',['재청소','재방문','A/S','재작업'],true,'결과가 만족스럽지 않을 때 재청소가 가능한지, 조건과 기한을 알려 주세요.'],
  ['clean-item-20','worker','휴게시간·안전',['휴게','식사','안전조치'],false,'담당자 휴게시간과 안전에 관해 제가 준비할 것이 있는지 알려 주세요.'],
  ['clean-item-21','worker','작업 인원',['매니저','인원','팀'],false,'몇 분이 오시는지와 인원이 바뀔 때 처리를 확인 부탁드려요.'],
  ['clean-item-22','dispute','분쟁 해결 방법',['민원','조정','상담창구'],false,'문제가 생겼을 때 어디로 접수하는지 알려 주세요.'],
];

/**
 * 시행규칙 제6조 필수 기재사항 11항목 → 체크리스트 매핑.
 * 미커버 0을 테스트가 검증한다. 근거: docs/08-content-data-cleaning.md §2.1
 */
export const statutoryCoverage: Array<{ no: number; requirement: string; itemIds: string[] }> = [
  { no: 1, requirement: '가사서비스의 종류', itemIds: ['clean-item-02'] },
  { no: 2, requirement: '가사서비스의 내용', itemIds: ['clean-item-03', 'clean-item-04'] },
  { no: 3, requirement: '제공일 및 제공시간', itemIds: ['clean-item-13', 'clean-item-14'] },
  { no: 4, requirement: '가사근로자 휴게시간', itemIds: ['clean-item-20'] },
  { no: 5, requirement: '가사근로자 안전에 관한 사항', itemIds: ['clean-item-20'] },
  { no: 6, requirement: '이용요금 및 지급방법', itemIds: ['clean-item-09', 'clean-item-10', 'clean-item-11'] },
  { no: 7, requirement: '안전사고 손해배상에 관한 사항', itemIds: ['clean-item-18'] },
  { no: 8, requirement: '내용·제공일·제공시간 변경 방법 및 절차', itemIds: ['clean-item-16'] },
  { no: 9, requirement: '이용 신청 취소 및 계약 해지 방법 및 절차', itemIds: ['clean-item-17'] },
  { no: 10, requirement: '휴일·휴가 시 조치', itemIds: ['clean-item-15'] },
  { no: 11, requirement: '분쟁 해결 방법', itemIds: ['clean-item-22'] },
];

export const cleaningPack: PackContract = {
  packId: 'cleaning',
  name: '청소',
  documentName: '청소 견적서·이용계약서',
  anchor: {
    doc: '가사근로자의 고용개선 등에 관한 법률',
    article: '제11조 · 시행규칙 제6조',
    force: 'mandatory',
    appliesTo: '제7조 인증을 받은 가사서비스 제공기관과의 이용계약',
    url: 'https://www.easylaw.go.kr/CSP/CnpClsMain.laf?popMenu=ov&csmSeq=1810&ccfNo=3&cciNo=1&cnpClsNo=1',
    checkedAt: '2026-08-14',
  },
  providerBranch: true,
  groups: ['provider', 'scope', 'price', 'time', 'change', 'safety', 'worker', 'dispute'],
  serviceDayLabels: ['D-1', '방문 당일', '정기 회차'],
  checklist: rows.map(([id, group, label, aliases, critical, question]) =>
    ({ id, group, label, aliases, critical, question })) as ChecklistItem[],
  implemented: true,
};
